/* eslint-disable import/prefer-default-export */

// import React from 'react';

import Admin from 'hive-admin';

import { renderCurrency } from './SystemCountry';
import Types from '../modules/types';

import FieldTable, { InputCheckbox } from './FieldTable';

const {
  PRODUCT_ATTRIBUTE,
  PRODUCT_ATTRIBUTE_LABELS_MAP,
} = Types;

Admin.addToLibrary(
  'FieldProductAttributes',
  config => FieldTable.create({
    label: 'Extra Shipping Fees Per Attribute',
    table: { showHeader: false, rowKey: 'key', size: 'small' },
    // eslint-disable-next-line max-len
    // help: (
    //   <>
    //     Limit payment options acceptable when shipping with
    //     {
    //         config.helpShippingLabel
    //       ? ` ${config.helpShippingLabel} shipping.`
    //       : ' this shipping provider.'
    //     }
    //     <br />
    //     <br />
    //     The final choices presented to the customer may vary based on
    //     many factors (eg. customers country, amount being charged, etc.).
    //   </>
    // ),
    productAttributes: PRODUCT_ATTRIBUTE,
    prepareValueForInput: (value = {}, props) => (
      props.productAttributes
      .reduce(
        (agr, key) => {
          if (value && value[key]) {
            agr.push({
              supported: true,
              ...value[key],
              key,
            });
          } else {
            agr.push({
              key,
              supported: false,
              fixed: 0,
              percentage: 0,
            });
          }
          return agr;
        },
        [],
      )
    ),
    prepareValueForForm: (value, props) => value.reduce(
      (agr, row, index) => {
        agr[props.productAttributes[index]] = row;
        return agr;
      },
      {},
    ),
    columns: [
      {
        key: 'supported',
        align: 'center',
        width: '50px',
        fields: [{
          name: 'supported',
          ComponentInput: InputCheckbox,
          props: {
            size: 'small',
          },
        }],
      },
      {
        key: 'label',
        getLabel: ({ key }) => PRODUCT_ATTRIBUTE_LABELS_MAP[key],
      },
      ...(
        config.skipPrice
        ? []
        : [{
            key: 'fixed',
            width: '160px',
            fields: [{
              name: 'fixed',
              props: {
                size: 'small',
                align: 'right',
                placeholder: 'Fixed',
              },
              // eslint-disable-next-line max-len
              getProps: ({ props }, { supported, fixed } = {}) => ({
                ...props,
                addonBefore: renderCurrency(),
                disabled: !supported,
                value: supported ? fixed : 'disabled',
              }),
            }],
          }, {
            key: 'percentage',
            width: '160px',
            fields: [{
              name: 'percentage',
              props: {
                size: 'small',
                align: 'right',
                placeholder: 'Percentage',
              },
              // eslint-disable-next-line max-len
              getProps: ({ props }, { supported, percentage } = {}) => ({
                ...props,
                // addonBefore: renderCurrency(),
                addonAfter: '%',
                disabled: !supported,
                value: supported ? percentage : 'disabled',
              }),
            }],
          }]
      ),
    ],
    ...config,
  }),
);
